export default [
    {
        icon: 'GridIcon',
        route: 'follow-up',
        title: 'Follow up'
    },
]
